module.exports = __webpack_public_path__ + "media/images/salespartner/bg-mv-right_sp-95b0132a33b5bf5313f7653621870260.svg";